import * as React from 'react'
import { Menu as MenuIcon } from 'react-feather'

import { useDisableBodyScroll } from '@avantstay/backoffice-core'

import { RouteKey } from '@routes'
import { isIos } from '@utils/isIos'

import { Menu } from './Menu'
import * as S from './MobileMenu.styles'

interface MobileMenuProps {
  items: RouteKey[]
}

export function MobileMenu({ items }: MobileMenuProps) {
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleOpening = () => setIsOpen(a => !a)
  const closeMenu = () => setIsOpen(false)

  useDisableBodyScroll(isIos && isOpen)

  return (
    <S.NavigationContainer>
      <MenuIcon onClick={toggleOpening} />

      <Menu isOpen={isOpen} items={items} onSelect={closeMenu} onClose={closeMenu} />

      <S.Overlay className={isOpen ? 'is-open' : ''} onClick={toggleOpening} />
    </S.NavigationContainer>
  )
}
